import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-950/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-movie-2-fill text-primary-500 text-2xl"></i>
            </div>
            <span className="text-xl font-heading font-bold text-foreground-50">
              七七影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : isScrolled || !isHome
                  ? 'text-foreground-300 hover:text-primary-400'
                  : 'text-foreground-50 hover:text-primary-400'
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <button
                className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center gap-1 ${
                  location.pathname.startsWith('/category')
                    ? 'text-primary-500'
                    : isScrolled || !isHome
                    ? 'text-foreground-300 hover:text-primary-400'
                    : 'text-foreground-50 hover:text-primary-400'
                }`}
              >
                分类
                <i className="ri-arrow-down-s-line text-xs"></i>
              </button>
              <div className="absolute top-full left-1/2 -translate-x-1/2 pt-4 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                <div className="bg-background-900 rounded-lg shadow-lg p-3 grid grid-cols-2 gap-1 min-w-[200px] border border-background-700">
                  {categories.slice(1).map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="flex items-center gap-2 px-3 py-2 rounded-md text-sm text-foreground-300 hover:text-primary-400 hover:bg-background-800 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      <i className={`${cat.icon} text-base`}></i>
                      {cat.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : isScrolled || !isHome
                  ? 'text-foreground-300 hover:text-primary-400'
                  : 'text-foreground-50 hover:text-primary-400'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="flex items-center gap-3">
            <div className="relative hidden md:block">
              <input
                type="text"
                placeholder="搜索电影、电视剧..."
                className="w-48 px-3 py-1.5 pl-9 text-sm bg-background-800 border border-background-700 rounded-full text-foreground-300 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500/50 transition-colors"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
            </div>
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
              aria-label="菜单"
            >
              <i
                className={`text-2xl ${
                  isScrolled || !isHome
                    ? 'text-foreground-300'
                    : 'text-foreground-50'
                } ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}
              ></i>
            </button>
          </div>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-950/98 backdrop-blur-md border-t border-background-800">
          <div className="px-4 py-4 flex flex-col gap-2">
            <Link
              to="/"
              className={`px-3 py-2 rounded-md text-sm font-medium cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-500 bg-background-800'
                  : 'text-foreground-300 hover:text-primary-400'
              }`}
            >
              首页
            </Link>
            {categories.slice(1).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500 bg-background-800'
                    : 'text-foreground-300 hover:text-primary-400'
                }`}
              >
                <i className={`${cat.icon} text-base`}></i>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-3 py-2 rounded-md text-sm font-medium cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-500 bg-background-800'
                  : 'text-foreground-300 hover:text-primary-400'
              }`}
            >
              关于我们
            </Link>
            <div className="relative mt-2">
              <input
                type="text"
                placeholder="搜索电影、电视剧..."
                className="w-full px-3 py-2 pl-9 text-sm bg-background-800 border border-background-700 rounded-full text-foreground-300 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500/50"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}